import { forwardRef } from 'react';
import {
  ListItemIcon as MuiListItemIcon,
  ListItemIconProps as MuiListItemIconProps,
} from '@mui/material';

/**
 * ListItemIcon component - Icon container for list items.
 *
 * This is a thin wrapper around Material-UI's ListItemIcon component that provides:
 * - Consistent icon sizing and spacing
 * - Left-aligned icon positioning
 * - Theme color integration
 * - Proper alignment with ListItemText
 *
 * Common use cases:
 * - Navigation menu icons
 * - Status indicators (checkmarks, warnings)
 * - Action icons in list items
 * - Category icons
 *
 * @example
 * // Basic icon in list item
 * <ListItem>
 *   <ListItemIcon><CheckIcon /></ListItemIcon>
 *   <ListItemText primary="Completed" />
 * </ListItem>
 *
 * @example
 * // Navigation with icon
 * <ListItemButton>
 *   <ListItemIcon><HomeIcon /></ListItemIcon>
 *   <ListItemText primary="Home" />
 * </ListItemButton>
 */
export type ListItemIconProps = MuiListItemIconProps;

export const ListItemIcon = forwardRef<HTMLDivElement, ListItemIconProps>((props, ref) => (
  <MuiListItemIcon ref={ref} {...props} />
));

ListItemIcon.displayName = 'ListItemIcon';
